
import { defineComponent } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';

export default defineComponent({
    name: 'GiftPackagingLineItemIsActivated',
    setup() {
        const labels = useBlockLabels();
        return {
            labels,
        };
    },
});
